import {SET_INITIALS_VALUE} from '../actions/userFormInitialValuesAction'

const initialState = {

};


const setInitialValues = (state, action) => {
    return {
        ...state,
        playerTypeList: action.data.playerTypeList,
        roles:action.data.roles,
        businessList:action.data.business,
        coachList:action.data.coachList
    }
}

const userFormInitialValues = (state = initialState, action) => {
    switch (action.type) {
        case SET_INITIALS_VALUE: return setInitialValues(state, action);
        default:
        return state;
    }
};


export default userFormInitialValues;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/userFormInitialValuesReducer.js
 **/